import { render, staticRenderFns } from "./InvoiceFillingMassive.vue?vue&type=template&id=2f65ea66&scoped=true"
import script from "./InvoiceFillingMassive.vue?vue&type=script&lang=js"
export * from "./InvoiceFillingMassive.vue?vue&type=script&lang=js"
import style0 from "./InvoiceFillingMassive.vue?vue&type=style&index=0&id=2f65ea66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65ea66",
  null
  
)

export default component.exports